import { animate, state, style, transition, trigger } from '@angular/animations';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTree, MatTreeNestedDataSource } from '@angular/material/tree';
import { BaseComponent } from 'src/app/@base/base.component';
import { PERMITION_BANK, PERMITION_CONSORTIUM, PERMITION_INSURANCE, PERMITION_REPORTS, PERMITION_SETTINGS } from 'src/app/const/permitions';
import { EnumPages } from 'src/app/enum/pages';
import { Route } from 'src/app/models/route';
import * as _ from 'lodash';
import { MatMenu } from '@angular/material/menu';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations:[
    trigger('slideVertical', [
      state('*', style( {height: 0} )),
      state('show', style( {height: '*'} )),
      transition('* => *', [animate('600ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
    ])
  ]

})
export class MenuComponent extends BaseComponent {


  @Output() emitCloseMenu: EventEmitter<void> = new EventEmitter();
  @Input() eixo: string = "horizontal";

  public settingsPermission: string = PERMITION_SETTINGS
  public reportsPermission: string = PERMITION_REPORTS
  public consortiumPermission: string = PERMITION_CONSORTIUM
  public bankPermission: string = PERMITION_BANK
  public insurancePermission: string = PERMITION_INSURANCE

  public routesMenuSettings: Route[] = this.routesSetting();
  public routesMenuConsortium: Route[] = this.routesConsortium();
  public routesMenuBank: Route[] = this.routesBank();
  public routesMenuInsurance: Route[] = this.routesInsurance();
  public routesMenuReports: Route[] = this.routesReports();

  public treeControl = new NestedTreeControl<Route>(node => node.children);

  public isExpanded: boolean = false;

  public dataSourceMenu = new MatTreeNestedDataSource<Route>();
  public dataSourceConsortium = new MatTreeNestedDataSource<Route>();

  constructor(){
    super()




    this.dataSourceMenu.data = this.routes.filter(x => x.menu).map(x => {
      if(x.name == EnumPages.CONSORTIUM){
        return {
          ...x,
          children: this.routesConsortium()
        }
      }
      if(x.name == EnumPages.SETTINGS){
        return {
          ...x,
          children: this.routesSetting()
        }
      }
      if(x.name == EnumPages.BANK){
        return {
          ...x,
          children: this.routesBank()
        }
      }
      if(x.name == EnumPages.INSURANCE){
        return {
          ...x,
          children: this.routesInsurance()
        }
      }
      return x
    });

  }

  public hasChild = (_: number, node: Route) => !!node.children && node.children.length > 0;

  public routesMenu(): Route[]{
    return this.routes.filter(x => x.menu && x.name != EnumPages.SETTINGS && x.name != EnumPages.CONSORTIUM && x.name != EnumPages.BANK && x.name != EnumPages.INSURANCE && x.name != EnumPages.REPORTS)
  }

  private routesSetting(): Route[] {
    return this.routes.find(x => x.name == EnumPages.SETTINGS).children.filter(x => x.children).flatMap(x => x.children).filter(x => x.path.includes("search") && x.permissions.some(r=> this.getPermissions().includes(r)))
  }

  private routesConsortium(): Route[] {
    return this.routes.find(x => x.name == EnumPages.CONSORTIUM).children
    .flatMap(x => x.children ? x.children : [x])
    .filter(x => x.permissions.some(r => this.getPermissions().includes(r)));
  }
  private routesBank(): Route[] {
    return this.routes.find(x => x.name == EnumPages.BANK).children
    .flatMap(x => x.children ? x.children : [x])
    .filter(x => !x.avoidOnMenu && x.permissions.some(r => this.getPermissions().includes(r)));
  }
  private routesInsurance(): Route[] {
    const itens = this.routes.find(x => x.name == EnumPages.INSURANCE).children
      .flatMap(x => x.children ? x.children : [x])
      .filter(x => x.permissions.some(r => this.getPermissions().includes(r)));
    return itens;
  }

  private routesReports(): Route[] {
    return this.routes.find(x => x.name == EnumPages.REPORTS).children
                      .filter(x => x.permissions.some(r=> this.getPermissions().includes(r)))
    ;
  }

  public returnDataCy(eixo: string, name: string): string {
    return "menu-" + eixo + "-" + name
  }

  public closeMenu(): void {
    this.emitCloseMenu.emit()
  }

  public closeMenuConsortium(consortiumMenu: MatMenu) {
    this.cleanConsortiumTree();
    consortiumMenu.closed.next();
    this.closeMenu()
  }

  public buildConsortiumTree(){
    this.dataSourceConsortium.data = _.orderBy(this.routes.find(x => x.name == EnumPages.CONSORTIUM).children, ['name']).filter(x => x.permissions.some(r => this.getPermissions().includes(r))).map(x => {

      return {
        ...x,
        children: _.orderBy(x.children, ["name"])
      }
    })
  }

  private cleanConsortiumTree(){
    this.dataSourceConsortium.data = []
  }
}
